import PropTypes from 'prop-types';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import { className } from '../../../../utils/GlobalCssProxy';

const ModelStrategy = ({ heading, bodyText, buttonText }) => {
  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_ModelStrategy"
      data-analytics-section="component"
    >
      <CardModule.Header>{heading}</CardModule.Header>
      <CardModule.Body>
        <p {...className('paragraph-standard')}>{bodyText}</p>
      </CardModule.Body>
      <CardModule.Footer>
        <ButtonDisclosures.Button
          variant="outline-black"
          module="note-about-risks"
          classes={['text-uppercase']}
        >
          {buttonText}
        </ButtonDisclosures.Button>
      </CardModule.Footer>
    </CardModule>
  );
};

ModelStrategy.propTypes = {
  /**
   * Heading displayed on module
   */
  heading: PropTypes.string,
  /**
   * Text to appear in body
   */
  bodyText: PropTypes.string,
  /**
   * Button text to show
   */
  buttonText: PropTypes.string
};

ModelStrategy.defaultProps = {
  heading: 'Model Strategy',
  buttonText: 'A Note About Risks'
};

export default ModelStrategy;
